<template>
  <div class="box7_main">
    <div class="title">
      <h3>报警信息</h3>
      <div class="r_block">
        <span></span>
        <em></em>
        <span></span>
      </div>
    </div>
    <div class="content">
      <ul class="con_head clearfix">
          <li>设备识别号</li>
          <li>报警时间</li>
          <li>报警内容</li>
      </ul>
      <div class="messages" @click="$router.push('/light/warnning')">
        <div class="content-issue" v-if="itemData.length">
          <ul class="clearfix" v-for="(item, index) in itemData" :key="index">
            <li>{{item.number}}</li>
            <li>{{item.date}}</li>
            <li>{{item.content}}</li>
          </ul>
        </div>
        <div class="content-issue" v-else>
          <ul class="clearfix">
            <li style="width:90%;text-align:center">暂无报警信息</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="r_block">
        <span></span>
        <em></em>
        <span></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Box7',
  props: {
    itemData: {
      type: Array,
      required: true,
      default: function () {
        return [

        ]
      }
    }
  },
  data() {
    return {
    }
  }
};
</script>
<style lang='less' scoped>
.box7_main {
  width: 100%;
  height: 100%;
  position: relative;
  .title {
    height:48px;
    display: flex;
    align-items: center;
    justify-content: flex-start ;
    width: 100%;
    background-image: url(../../assets/home_images/title_bg.png);
    background-position: 0 center;
    background-repeat: no-repeat;
    position: relative;
    h3{
      font-size: 20px;
      font-weight: normal;
      color: #fff;
      padding-left: 20px;
      margin:0;
      margin-top:5px;
    }
    .r_block{
      position: absolute;
      right:0;
      bottom:9px;
      display: flex;
      align-items: center;
      span{
        width:3px;
        height:7px;
        background: #1de7ff;
        display: block;
      }
      em{
        width:12px;
        height:7px;
        background: #01162b;
        display: block;
      }
    }
  }
  .bottom{
    height:4px;
    display: flex;
    align-items: center;
    justify-content: flex-start ;
    width: 100%;
    background-image: url(../../assets/home_images/con_bot.png);
    background-position: 0 center;
    background-repeat: no-repeat;
    position: absolute;
    bottom: 0;
    left: 0;
    .r_block{
      position: absolute;
      right:0;
      bottom:0px;
      display: flex;
      align-items: center;
      span{
        width:4px;
        height:4px;
        background: #1de7ff;
        display: block;
      }
      em{
        width:10px;
        height:4px;
        background: #01162b;
        display: block;
      }
    }
  }
  .content{
    position: absolute;
    top: 48px;
    bottom: 4px;
    left: 0;
    right:0;
    overflow: hidden;
    flex-direction: column;
    justify-content: space-between;
    background-image: url(../../assets/home_images/con_left.png);
    background-position: 0 0;
    background-repeat: no-repeat;
    box-sizing: border-box;
    padding: 0 20px;
    .con_head{
      position:absolute;
      top:0;
      left:20px;
      right:20px;
      list-style: none;
      margin:0;
      box-sizing: border-box;
      height:31px;
      padding:0;
      border-bottom:1px solid #1de7ff;
      li{
        float: left;
        height:30px;
        line-height:30px;
        color:#1de7ff;
        font-size:12px;
        text-align: center;
        width:45%;
      }
      li:first-child{
        box-sizing: border-box;
        width:30%;
      }
      li:last-child{
        box-sizing: border-box;
        width:25%;
      }
    }
    .messages {
      position: relative;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      overflow: hidden;
      padding-top: 31px;
      .content-issue{
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: space-evenly; /* 水平均匀分布 */
        align-items: center; /* 垂直居中 */
        flex-direction: column;
        ul{
          height:24px;
          cursor: pointer;
          list-style: none;
          margin:0;
          padding:0;
          width:100%;
          li{
            float: left;
            color:#fff;
            font-size:12px;
            text-align: center;
            height: 24px;
            line-height: 24px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width:45%;
          }
          li:first-child{
            box-sizing: border-box;
            width:30%;
          }
          li:last-child{
            box-sizing: border-box;
            width:25%;
          }
        }
        ul:hover li{
          color:#fff
        }
      }
    }
    .none_data{
      font-size:14px;
      color: #fff;
      width:100%;
      height:100%;
      display: flex;
      justify-content: center; /* 水平居中 */
      align-items: center;     /* 垂直居中 */
      text-align:center;
    }
    
  }
  
}


</style>